export default "__VITE_ASSET__CKuG6tG$__"